import { formatAge } from '../format.js';
import { currentProduct, latestAgeSeconds } from '../state/store.js';

export const StatusBar = () => (
  <footer class="status">
    <span>{currentProduct.value?.name ?? ''}</span>
    <span>Última imagen: {formatAge(latestAgeSeconds.value)}</span>
    <a class="status__link" href="https://www.euskalmet.euskadi.eus/" target="_blank" rel="noopener noreferrer">
      Datos: Euskalmet – Agencia Vasca de Meteorología
    </a>
  </footer>
);
